import googleLogo from '../assets/logos/google.svg?url';
import microsoftLogo from '../assets/logos/microsoft.svg?url';

// External logos
const autodeskLogo = 'https://assets.streamlinehq.com/image/private/w_300,h_300,ar_1/f_auto/v1/icons/design/autodesk-2-h8ur5kqfkkqup31kg7xl7i.png/autodesk-2-wf79dxciibniryh8nsa0s.png?_a=DATAg1AAZAA0';
const trimbleLogo = 'https://companieslogo.com/img/orig/TRMB-f6434f42.png?t=1720244494';
const buildagilLogo = 'https://www.swissbau.ch/media/provider_logo/8193a32ee46aeeb9aff8391195c57e8ed27aa7699ae8807fc24cc530a5d1ddd3.jpg';

/**
 * Returns a logo component for the given provider type
 */
export const getProviderLogo = (providerType: string, size: 'sm' | 'md' | 'lg' = 'md') => {
  const sizeClasses = {
    sm: 'h-6 w-6',
    md: 'h-10 w-10',
    lg: 'h-16 w-16',
  };

  const sizeClass = sizeClasses[size];

  // Handle missing provider type
  if (!providerType) {
    return (
      <div className={`${sizeClass} bg-gray-400 rounded flex items-center justify-center`}>
        <svg className="w-3/4 h-3/4" viewBox="0 0 24 24" fill="white" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/>
        </svg>
      </div>
    );
  }

  const normalizedType = String(providerType).toLowerCase();

  switch (normalizedType) {
    case 'google':
      return <img src={googleLogo} alt="Google" className={`${sizeClass} object-contain`} />;

    case 'microsoft':
      return <img src={microsoftLogo} alt="Microsoft" className={`${sizeClass} object-contain`} />;

    case 'autodesk':
      return <img src={autodeskLogo} alt="Autodesk" className={`${sizeClass} object-contain`} />;

    case 'trimble':
      return <img src={trimbleLogo} alt="Trimble" className={`${sizeClass} object-contain`} />;

    case 'buildagil':
      return <img src={buildagilLogo} alt="BuildAgil" className={`${sizeClass} object-contain rounded`} />;

    case 'custom':
      return (
        <div className={`${sizeClass} bg-gray-600 rounded flex items-center justify-center`}>
          <svg className="w-3/4 h-3/4" viewBox="0 0 24 24" fill="white" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 2L2 7v10c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V7l-10-5z"/>
          </svg>
        </div>
      );

    default:
      return (
        <div className={`${sizeClass} bg-blue-500 rounded flex items-center justify-center`}>
          <svg className="w-3/4 h-3/4" viewBox="0 0 24 24" fill="white" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/>
          </svg>
        </div>
      );
  }
};

/**
 * Returns a small inline badge-style logo for the given provider type
 */
export const getProviderBadge = (providerType: string) => {
  return getProviderLogo(providerType, 'sm');
};
